
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';
import officeSearchTpl from '!!file-loader?name=templates/[name].[ext]!./officeSearch.html';

/**
 *	Directive used for manipulate the HTML DOM elements inside the officeSearch component
 * @returns
 */
function officeSearchComponent() {

	/**
	 * Directive definition.
	 */
	const directive = {
		restrict: 'E',
		templateUrl: officeSearchTpl,
		controller: OfficeSearchController,
		controllerAs: 'officesearchvm',
		bindToController: true,
		scope: {
			receiver: '='
		}
	};

	return directive;

	/**
	 * Controller used by directive for search offices
	 */
	function OfficeSearchController(utilitiesConstant, utilitiesFactory, restClientServices, officeSearchConstant) {
		'ngInject';

		/**
		 * Scope for manipulated data in HTML DOM elements.
		 */
		let vm = this;
		vm.offices = [];
		vm.constant = officeSearchConstant;

		/**
		 * Filters offices by name and code.
		 */
		vm.searchOffice = searchText => vm.offices.filter(office => _.includes(office.name.toLowerCase(), searchText.toLowerCase()) || _.includes(office.code, searchText)
		);

		(function () {
			/**
			 * Gets offices from the server.
			 */
			const officesUrl = utilitiesConstant.URL_ENDPOINT_GANA.concat(utilitiesConstant.URL_API_METHOD.OFFICES);

			restClientServices.ganaService(officesUrl)
				.then(response => {
					vm.offices = response.offices;
				},
				error => {
					if(error.status === 404) {
						utilitiesFactory.showAlertMessage(officeSearchConstant.NOT_FOUND_OFFICES);
					} else {
						utilitiesFactory.showErrorMessage(utilitiesConstant.MSG_ERROR);
					}
				});
		})();
	}
}

export default officeSearchComponent;



// WEBPACK FOOTER //
// ./src/app/core/components/officeSearch/officeSearch.directive.js